import InvestmentDeclarationDetail from "./investmentDeclarationDetail.";
export default InvestmentDeclarationDetail;